<script setup lang="ts">
/**
 * Libraries
 */

import { onMounted, provide } from 'vue';
import { DefaultApolloClient } from '@vue/apollo-composable';

import { useHead } from 'unhead';

import 'clockwork-browser/dist/metrics.js';

/**
 * Apollo
 */

import apolloClient from '@core/apollo';

/**
 * Components
 */

import UILoader from '@sharedLoader/UILoader.vue';

import { bootstrapIntercomSnippet } from '@config/intercom';

useHead({
  title: 'NTU',
});

provide(DefaultApolloClient, apolloClient);

onMounted(() => {
  if (!import.meta.env.DEV) {
    bootstrapIntercomSnippet();
  }
});
</script>

<template>
  <Suspense>
    <RouterView />
    <template #fallback>
      <div class="flex h-screen items-center justify-center">
        <UILoader class="text-semantic-primaries-brand-0" />
      </div>
    </template>
  </Suspense>
</template>
